<template>
	<Modal 
		:title="'ALTERAÇÃO'"
		:loading="loading"
		@close="close"
		@save="save"
	>
		<div class="row">
			<div class="col-xs">
				<small><b>Informações gerais</b></small>
			</div>
		</div>

		<div class="row">
			<div class="col-xs-12 col-sm-6 col-md-8 col-lg-8">
				<FormInput type="text" label="Nome da empresa" icon="fa-align-left" v-model="form.name" />
			</div>
			<div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
				<FormInput type="text" label="CNPJ/CPF" icon="fa-id-card" v-model="form.document" />
			</div>
		</div>

		<div class="row">
			<div class="col-xs-12 col-sm-4 col-md-6 col-lg-6">
				<FormInput type="text" label="Nome do contato" icon="fa-user" v-model="form.contact_name" />
			</div>
			<div class="col-xs-12 col-sm-4 col-md-6 col-lg-6">
				<FormInput type="email" label="E-mail do contato" icon="fa-envelope" v-model="form.contact_email" />
			</div>
			<div class="col-xs-12 col-sm-4 col-md-6 col-lg-6">
				<FormInput type="text" label="Telefone do contato" icon="fa-phone" v-model="form.contact_phone" />
			</div>
			<div class="col-xs-12 col-sm-4 col-md-6 col-lg-6">
				<FormDate type="text" label="Data de vencimento" icon="fa-calendar" v-model="form.valid_until" />
			</div>
		</div>

		<div class="row" style="margin-bottom: 1rem;">
			<div class="col-xs">
				<FormTextarea type="text" label="Endereço" icon="fa-map-marked-alt" v-model="form.address" />
			</div>
		</div>

		<div class="row">
			<div class="col-xs">
				<small><b>Informações de sincronização</b></small>
			</div>
		</div>

		<div class="row">
			<div class="col-xs input-margin-top">
				<FormCheckbox label="Cliente ATAK" icon="fa-award" v-model="form.client_atak" />
			</div>
		</div>

		<div class="row">
			<div class="col-xs">
				<small><b>Informações de roteirização</b></small>
			</div>
		</div>

		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
				<FormSelect :options="{1: 'Ativo', 0: 'Inativo'}" v-model="form.routing" label="Roteirizador" icon="fa-route" />
			</div>
			<!-- <div v-if="form.routing == 1" class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
				<FormInputMasked type="tel" v-model="form.routing_limit" label="Roteirização diária" icon="fa-route" :mask="['###']" ref="routing_limit" />
			</div> -->
		</div>

	</Modal>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormInput from "@/components/FormInput";
import FormTextarea from "@/components/FormTextarea";
import FormDate from "@/components/FormDate";
import FormCheckbox from "@/components/FormCheckbox";
import FormSelect from "@/components/FormSelect";
// import FormInputMasked from "@/components/FormInputMasked";

export default {
	name: "AdminCompanyForm",

	props: [ "current" ],

	components: {
		Modal,
		FormInput,
		FormTextarea,
		FormDate,
		FormCheckbox,
		FormSelect,
		// FormInputMasked
	},

	data: function() {
		let form = {};

		if (this.current == 'new') {
			form = {
				document: "",
				name: "",
				address: "",
				valid_until: "",
				contact_name: "",
				contact_email: "",
				contact_phone: "",
				client_atak: 0,
				routing: 0,
				// routing_limit: 0,
			}
		} else {
			form = {
				document: this.current.document,
				name: this.current.name,
				address: this.current.address,
				valid_until: this.current.valid_until.split('-').reverse().join('/'),
				contact_name: this.current.contact_name,
				contact_email: this.current.contact_email,
				contact_phone: this.current.contact_phone,
				client_atak: this.current.client_atak,
				routing: this.current.routing,
				// routing_limit: this.current.routing_limit ? this.current.routing_limit : 0,
			}
		}

		return {
			loading: false,
			form: form,
		};
	},

	methods: {
		save: async function() {
			let delta = {};

			if (this.current == 'new') {
				delta = this.form;
			} else {
				if (this.form.document != this.current.document) delta.document = this.form.document;
				if (this.form.name != this.current.name) delta.name = this.form.name;
				if (this.form.address != this.current.address) delta.address = this.form.address;
				if (this.form.contact_name != this.current.contact_name) delta.contact_name = this.form.contact_name;
				if (this.form.contact_email != this.current.contact_email) delta.contact_email = this.form.contact_email;
				if (this.form.contact_phone != this.current.contact_phone) delta.contact_phone = this.form.contact_phone;
				if (this.form.client_atak != this.current.client_atak) delta.client_atak = this.form.client_atak;
				if (this.form.routing != this.current.routing) delta.routing = this.form.routing;
				// if (this.form.routing_limit != this.current.routing_limit)
				// 	delta.routing_limit = this.form.routing_limit;
				// else if (this.form.routing == 0)
				// 	delta.routing_limit = 0;

				if (this.form.valid_until != this.current.valid_until.split('-').reverse().join('/')) {
					delta.valid_until = this.form.valid_until;
				}

				delta.id = this.current.id;
			}

			if (Object.keys(delta).length < 2) {
				this.close();
				return;
			}

			this.loading = true;
			let res = await Api.post_admin("company/save", delta);
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.$notification.success("Salvo com sucesso.");

			this.$parent.load();
			this.close();
		},

		close: function() {
			this.$parent.current = false;
		}
	},
}
</script>

<style scoped>
.input-margin-top {
	margin-top: 25px;
}
	
</style>